export const getAssetURL = (filename) => encodeURI(`${process.env.REACT_APP_ASSET_URL}${filename}`);

export const getPostDate = (date) => {
  const postDate = new Date(date);
  return `${postDate.getMonth() + 1}/${postDate.getDate()}/${postDate.getFullYear()}`;
};

export function isMobileOrTablet() {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const isMobile = width <= 768 && height <= 1024; // Adjust the values as needed
  const isTablet = width > 768 && width <= 991; // Adjust the values as needed
  return isMobile || isTablet;
}
export const cleanURLString = (input) =>
  input
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9\- ]/g, "") // Remove unwanted characters except hyphen and space
    .replace(/ /g, "-") // Replace spaces with hyphens
    .replace(/-{2,}/g, "-") // Replace multiple consecutive hyphens with a single hyphen
    .replace(/^-/, "");

export const blogCategories = [
  "Homebuying",
  "Refinance",
  "Technology",
  "Lifestyle",
  "Mortgage 101",
  "News",
  "Testimonials",
];

export const getCategoryBlogs = (blogs) => {
  const normalizedCategory = (category) => category.toLowerCase().replace(" ", "");
  const categoryBlogs = {};
  blogCategories.forEach((category) => {
    const categoryName = normalizedCategory(category);
    categoryBlogs[categoryName] = blogs?.find((blog) => blog?.tag === categoryName);
  });
  return categoryBlogs;
};
